<ng-container *ngIf="formRef?.control as formRefControl">
  <form [formGroup]="formRefControl" class="cmn-forms">
    <div>
      <h2 class="formSection__header">Source Site Contacts</h2>
      <div class="formGrid__esvr formGrid__esvr--3">
        <div class="siteInfo">
          <h2 class="input__title">Site Representative</h2>
          <div *ngIf="editing && isSourceSiteUser; else elseSourceSiteRepresentativeUniqueId">
            <mat-form-field floatLabel="never">
              <mat-select formControlName="sourceSiteRepresentativeUniqueId">
                <mat-option *ngFor="let option of sourceSiteUsers$ | async" [value]="option.userUniqueId">
                  {{ option.userName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ng-template #elseSourceSiteRepresentativeUniqueId>
            <p>{{ contactInfo?.sourceSiteRep }}</p>
          </ng-template>
        </div>
        <div class="siteInfo">
          <h2 class="input__title">Project leader</h2>
          <p>{{ contactInfo?.projectLeader?.name }}</p>
          <p>{{ contactInfo?.projectLeader?.phoneNumber }}</p>
          <p>{{ contactInfo?.projectLeader?.email }}</p>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div>
      <h2 class="formSection__header">Receiving Site Contact</h2>
      <div class="formGrid__esvr formGrid__esvr--3">
        <div class="siteInfo">
          <h2 class="input__title">Site Representative</h2>
          <div *ngIf="editing && isFillSiteUser; else elseFillSiteRepresentativeUniqueId">
            <mat-form-field floatLabel="never">
              <mat-select formControlName="fillSiteRepresentativeUniqueId">
                <mat-option *ngFor="let option of fillSiteUsers$ | async" [value]="option.userUniqueId">
                  {{ option.userName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ng-template #elseFillSiteRepresentativeUniqueId>
            <p>{{ contactInfo?.fillSiteRep }}</p>
          </ng-template>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div>
      <h1 class="formSection__header">Comments</h1>
      <div class="cmn-forms textArea">
        <mat-form-field class="confirmationContainer__reasonInput cmn-txtarea" appearance="outline" floatLabel="never">
          <textarea matInput formControlName="comments" placeholder="Comments..."> </textarea>
          <mat-error>{{ $any(formRefControl).controls.comments.errors | formError }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</ng-container>
